<template>
	<img v-if="visible" :src="imgUrl" :class="clazz" :style="style">
</template>

<script setup lang="ts">
import usePart, {type PartProps, partProps} from "../Part";

const uprops = defineProps({...partProps});
const props = uprops as PartProps;

const {visible, valueExpression, clazz, style} = usePart(props);

const imgUrl = valueExpression("value", "ex");
</script>

<style>
</style>